import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8735%3A20697
 *
 * @param {SvgIconProps} props - svg props
 */
export const EmailIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M1.72101 4C1.32281 4 1 4.32281 1 4.72101C1 4.85618 1.07561 4.97999 1.19586 5.04173L11.0866 10.1193C11.66 10.4137 12.34 10.4137 12.9134 10.1193L22.8041 5.04173C22.9244 4.97999 23 4.85618 23 4.72101C23 4.32281 22.6772 4 22.279 4H1.72101ZM1.78798 5.80526C1.45673 5.57188 1 5.80879 1 6.214V18.9998C1 19.5521 1.44772 19.9998 2 19.9998H22C22.5523 19.9998 23 19.5521 23 18.9998V6.214C23 5.80879 22.5433 5.57188 22.212 5.80526L13.1519 12.1885C12.4611 12.6752 11.5389 12.6752 10.8481 12.1885L1.78798 5.80526Z' fill={color}/>
        </SvgIcon>
    )
}

export default EmailIcon
